import { renderToStaticMarkup } from 'react-dom/server';
import classes from 'components/Charts/DonutChart/DonutChart.module.css';
import { SeriesClickEventObject, SeriesOptionsType } from 'highcharts';
import { t } from 'i18next';
import { DistributionValues, Orientation } from 'models/charts';

export interface DonutChartOptionsProps<I> {
  data?: DistributionValues<I>;
  onSubtitleClick?: () => void;
  onDistributionClick?: (label: string) => void;
  layout?: Orientation;
  labelPrefix?: string;
}

const renderSubtitle = (total?: number) => {
  return renderToStaticMarkup(
    <div>
      <span className={classes.headerTitle}> {total || 0} </span>
      <br />
      <span>{t('measurements_label')}</span>
    </div>,
  );
};

const renderTooltip = (point: Highcharts.Point & { key: string }) => {
  return renderToStaticMarkup(
    <div>
      <b>{`${point.key}: `}</b>
      <span> {point.y}</span>
    </div>,
  );
};

export const useDonutChartOptions = <I,>({ data, onSubtitleClick, onDistributionClick }: DonutChartOptionsProps<I>) => {
  const mappedData = data?.values.map((item) => {
    return {
      name: item.name,
      y: item.total,
      color: item.color,
      id: item.label,
    };
  });

  return {
    chart: {
      type: 'pie',
      height: '200px',
      events: {
        click: onSubtitleClick,
      },
    },
    title: { text: '' },
    subtitle: {
      text: renderSubtitle(data?.total),
      verticalAlign: 'middle',
      floating: true,
      style: { cursor: onSubtitleClick && 'pointer' },
    },
    plotOptions: {
      series: {
        animation: false,
      },
      pie: {
        enableMouseTracking: true,
        dataLabels: {
          enabled: false,
        },
      },
    },
    credits: { enabled: false },
    series: [
      {
        events: {
          click: ({ point }: SeriesClickEventObject) => {
            if (point.options?.id && onDistributionClick) {
              onDistributionClick(point.options.id);
            }
          },
        },
        data: mappedData,
        cursor: onDistributionClick && 'pointer',
        innerSize: '75%',
      },
    ] as Array<SeriesOptionsType>,
    tooltip: {
      enabled: true,
      formatter(this: Highcharts.Point & { key: string }) {
        return renderTooltip(this);
      },
    },
    accessibility: {
      enabled: false,
    },
  };
};
